import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

import PropertyAPI from '../../api/PropertyAPI';

import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import ProjectConst from '../../util/ProjectConst';
import Const from '../../util/Constants';

class InnerPropertyList extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).property;
    this.state = { inApiCall: true, properties: [] };
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    this.loadProperties();
  }
  allowedFieldKeys = ['property_type', 'type', 'build_area', 'carpet_area', 'price', 'agreement_price', 'developement_charge', 'parking_charges', 'society_charges', 'other_charges', 'stamp_duty', 'registration', 'wing' ];

  getVisibleFields = () => {
    if (!this.model || !this.model.fields) return [];

    return this.allowedFieldKeys
      .map(key => this.model.fields[key])
      .filter(field => field && field.visible === 1);
  };

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.loadProperties();
    }
  }

  loadProperties = () => {
    PropertyAPI.getInnerProjectList(this.props.id, this.onReceived,this.props.failure);
  }

  onReceived = res => { this.setState({ inApiCall: false, properties: res.data });}
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No',
    () => {
      this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.delete(this.state.properties[indx].id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.props.reload();
  }

  showList = () => {
    const visibleFields = this.getVisibleFields();

    return this.state.properties.map((property, index) => (
      <tr key={`property_${index}`}>

        {visibleFields.map(field => (
          <td key={field.field_key}>
            {Display.FieldValue(property, field.field_key, this.model.fields)}
          </td>
        ))}

        <td>
          {this.Update ? (
            <span
              className="buttons update"
              onClick={() => this.props.edit(property, ProjectConst.Property)}
            >
              <FaPencilAlt /> Edit
            </span>
          ) : null}

          {this.Delete ? (
            <span
              onClick={() => this.onDelete(index)}
              className="buttons delete"
            >
              <FaTrash /> Delete
            </span>
          ) : null}
        </td>

      </tr>
    ));
  };

  render() {
    let uiCalls = this.showList();
    if (this.state.properties.length === 0) {
      uiCalls = <tr> <td colSpan={this.getVisibleFields().length + 1}>No Records Found</td> </tr>;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Configurations</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
            <thead>
                <tr>

                  {this.getVisibleFields().map(field => (
                    <th key={field.field_key}>
                      {field.label_name}
                    </th>
                  ))}

                  <th className="actionth">Action</th>

                </tr>
              </thead>
              <tbody>{uiCalls}</tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(InnerPropertyList);
